/**
 * Catalogue des poses de Koffi, la mascotte Mokah+ (MOKA-214).
 *
 * Koffi s'appelait d'abord « Mokkie » : les fichiers gardent ce préfixe
 * (assets/images/mokkie/mokkie-*.png), seul le nom affiché a changé. C'est
 * aussi lui qui incarne l'assistant (assets/images/koffi/).
 *
 * Koffi est une tasse de café en rendu cartoon 3D. L'image d'origine
 * (assets/images/mokkie.png) ouvre la liste. Les 10 poses suivantes ont été
 * générées à partir d'elle (gpt-image-1, édition avec l'image de référence) :
 * PNG à fond transparent, 512×512, dans assets/images/mokkie/.
 * Le catalogue sert à varier la mascotte selon le contexte : états vides,
 * succès, chargement, modules. `usage` indique où placer chaque pose.
 */
export interface MascotPose {
  id: string;
  file: string;
  label: string;
  usage: string;
}

export const MOKKIE_POSES: readonly MascotPose[] = [
  {
    id: 'origine',
    file: 'assets/images/mokkie.png',
    label: 'Koffi en course',
    usage:
      'Pose de référence de la DA : logo animé, écrans de marque, illustration par défaut.',
  },
  {
    id: 'salut',
    file: 'assets/images/mokkie/mokkie-salut.png',
    label: 'Salut',
    usage:
      'Accueil : écran de connexion, onboarding, message de bienvenue du tableau de bord.',
  },
  {
    id: 'bravo',
    file: 'assets/images/mokkie/mokkie-bravo.png',
    label: 'Bravo',
    usage:
      'Succès : tout est à jour, tâche terminée, formulaire envoyé, objectif atteint.',
  },
  {
    id: 'reflexion',
    file: 'assets/images/mokkie/mokkie-reflexion.png',
    label: 'Réflexion',
    usage:
      "Chargement ou analyse en cours : calculs, génération par l'assistant, recherche.",
  },
  {
    id: 'lecture',
    file: 'assets/images/mokkie/mokkie-lecture.png',
    label: 'Lecture',
    usage:
      "Rapports et documents : exports, statistiques salariales, état vide d'une liste de documents.",
  },
  {
    id: 'calendrier',
    file: 'assets/images/mokkie/mokkie-calendrier.png',
    label: 'Calendrier',
    usage:
      'Module calendrier : semaine sans présence saisie, aucun événement à venir.',
  },
  {
    id: 'materiel',
    file: 'assets/images/mokkie/mokkie-materiel.png',
    label: 'Matériel',
    usage:
      "Module inventaire : bandeau d'accueil de l'inventaire, aucun équipement attribué, parc vide, demande de matériel.",
  },
  {
    id: 'guide',
    file: 'assets/images/mokkie/mokkie-guide.png',
    label: 'Guide',
    usage:
      "Guidage et tutoriel : pointe vers l'action à faire, à placer à gauche de la cible.",
  },
  {
    id: 'sieste',
    file: 'assets/images/mokkie/mokkie-sieste.png',
    label: 'Sieste',
    usage:
      'État vide calme : rien de nouveau, aucune notification, boîte de réception vide.',
  },
  {
    id: 'projets',
    file: 'assets/images/mokkie/mokkie-projets.png',
    label: 'Projets',
    usage:
      'Module gestion de projet : aucun projet, board sans tâche, création du premier projet.',
  },
  {
    id: 'micro',
    file: 'assets/images/mokkie/mokkie-micro.png',
    label: 'Micro',
    usage:
      "Assistant IA et commandes vocales : overlay de chat, écoute en cours, présentation de l'assistant.",
  },
];
